import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/dark.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import ContactUsForm from "components/forms/ContactUsFormOnly";

const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center mt-5`;
const Subheading = tw.p`text-center text-primary-500 font-bold uppercase tracking-widest text-sm mt-4`;
const Description = tw.p`text-center text-secondary-100 font-medium max-w-2xl mx-auto mt-4 leading-relaxed`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <div>
        <SectionHeading>Contact Us</SectionHeading>
        <Subheading>We'd love to hear from you</Subheading>
        <Description>
          Feel free to reach out with any inquiries or questions you have
          regarding our services.
        </Description>
      </div>
      <ContactUsForm wide heading="Let's discuss your patent needs" />
      <Footer />
    </AnimationRevealPage>
  );
};
